import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import OrdersAll from '../componets/jsonOrder/OrderAll.json';
import FavoriteIcon from '@mui/icons-material/FavoriteBorder';
import ErrorIcon from '@mui/icons-material/Error';

function Row(props) {
  var order = props.order;
  if (order.body === null) {
    order.body = []
  }
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <React.Fragment>
        <TableRow sx={{
          '& > *': { borderBottom: 'unset' },
        }} >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell align="left">{(new Date()).getHours() + ":" + (new Date()).getMinutes()}</TableCell>
          <TableCell component="th" scope="row">
            {order.id}
          </TableCell>
          <TableCell align="right">{order.table}</TableCell>
          <TableCell align="right">{order.people}</TableCell>
          <TableCell align="right">{order.tot + "€"}</TableCell>
          <TableCell align="right">{
            order.paid ? <FavoriteIcon /> : <ErrorIcon />
          }</TableCell>
        </TableRow>
      </React.Fragment>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead sx={{
                  '& .MuiTableCell-root': { color: '#fff2d7' },
                  '& .MuiTableRow-root ': { backgroundColor: '#16314c' }
                }}>
                  <TableRow>
                    <TableCell >Quantity</TableCell>
                    <TableCell>Dishe</TableCell>
                    <TableCell>Price (€)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{
                  '& .MuiTableCell-root': { color: '#16314c' },
                  '& .MuiTableRow-root ': { backgroundColor: '#fff2d7' }
                }}>
                  {order.body.map((body) => (
                    <TableRow key={open.id}>
                      <TableCell >{body.quantity}</TableCell>
                      <TableCell>{body.name}</TableCell>
                      <TableCell>
                        {body.price + "€ x " + body.quantity + " = " + Math.round(body.quantity * body.price)+"€"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

export default function Chef() {
  let order = OrdersAll.data.ordersAll
  return (
    <TableContainer
      component={Paper}
      sx={{
        '& .MuiTable-root': { backgroundColor: '#fff2d7' }
      }}
    >
      <Table aria-label="collapsible table" backgroundColor='#fff2d7'>
        <TableHead sx={{
          '& .MuiTableCell-root': { color: '#fff2d7' },
          '& .MuiTableRow-root ': { backgroundColor: '#16314c' }
        }} >
          <TableRow>
            <TableCell />
            <TableCell>Time</TableCell>
            <TableCell>Id</TableCell>
            <TableCell align="right">Table</TableCell>
            <TableCell align="right">People</TableCell>
            <TableCell align="right">Tot</TableCell>
            <TableCell align="right">Paid</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order.map((order) => (
            <Row key={order.id} order={order} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}